import { Validators } from "@angular/forms";
import { FormFieldTypes, IFormField } from "src/app/shared/modules/uikit-form/uikit-form.component";

export const QUICKSIGNIN_FORM_FIELDS: IFormField[] = [
    {
      label: '',
      type: FormFieldTypes.textinput,
      fieldId: 'email',
      placeholder: 'Enter your email',
      validators: [Validators.required, Validators.email]
    },
    {
        label: '',
        type: FormFieldTypes.toggle_switch,
        fieldId: 'agree_to_terms',
        validators: [Validators.requiredTrue],
        toggleSwitch: {
          offText: 'No',
          onText: 'Yes',
          offLabel: ' ',
          onLabel: 'I agree to receive newsletters via email.',
        }
    }
  ]